<section class="about-intro">
  <div class="container">
    <header class="about-head">
      <h1 class="about-head__title">{{ "MENU.ABOUT_US" | translate }}</h1>
    </header>

    <div class="about-intro__grid">
      <figure class="about-intro__media">
        <img
          src="./assets/media/landing/about-learning.webp"
          alt="ห้องสมุดตัวอย่าง"
          loading="lazy"
        />
      </figure>

      <div class="about-intro__body">
        <p class="about-intro__lead">
          {{ "ABOUT_US.ABOUT.LINE_1" | translate }}
          {{ "ABOUT_US.ABOUT.LINE_2" | translate }}
          {{ "ABOUT_US.ABOUT.LINE_3" | translate }}
          {{ "ABOUT_US.ABOUT.LINE_4" | translate }}
          {{ "ABOUT_US.ABOUT.LINE_5" | translate }}
          {{ "ABOUT_US.ABOUT.LINE_6" | translate }}
        </p>

        <!-- The demo notice was two lines of oversized italic floating in the
             column. It is an aside about the site itself, not part of the
             product description, so it gets its own surface. -->
        @if (demo.enabled) {
        <aside class="about-intro__note">
          <span class="about-intro__note-title">
            {{ "ABOUT_US.ABOUT.LINE_7" | translate }}
          </span>
          <span class="about-intro__note-body">
            {{ "ABOUT_US.ABOUT.LINE_8" | translate }}
          </span>
        </aside>
        }
      </div>
    </div>
  </div>
</section>
